import React from "react";
import {
	Create,
	DateTimeInput,
	ReferenceInput,
	SelectInput,
	SimpleForm,
	TextInput,
} from "react-admin";
import dateFormat from "dateformat";

const DonationCreate = (props) => (
	<Create
		{...props}
		transform={(data) => ({
			...data,
			donation_date: dateFormat(data.donation_date, "isoDateTime"),
		})}
	>
		<SimpleForm>
			{/*<TextInput source="id"/>*/}
			<TextInput source="amount" label="Montant" />
			<TextInput source="firstname" label="Prénom" />
			<TextInput source="lastname" label="Nom" />
			<DateTimeInput source="donation_date" label="Date du don" defaultValue={Date.now()} />
			<ReferenceInput source="campaign_id" reference="campaign">
				<SelectInput label="Campagne" optionText="abstract_title" />
			</ReferenceInput>
			<TextInput source="affectation_code" label="Code affectation" />
			<TextInput source="origin_code" label="Code origine" />
		</SimpleForm>
	</Create>
);

export default DonationCreate;
